import * as React from "react"
import { useTranslation } from "react-i18next"
import { cn } from "@/lib/utils"

export interface LoginHeaderProps {
  className?: string
}

export const LoginHeader: React.FC<LoginHeaderProps> = ({ className }) => {
  const { t } = useTranslation()

  return (
    <div className={cn("space-y-4", className)}>
      {/* Logo: shown only on mobile — desktop shows it on the brand panel */}
      <div className="flex justify-center lg:hidden animate-in fade-in zoom-in-95 duration-700">
        <img
          src="/logo.svg"
          alt="ambcar"
          className="w-full max-w-[280px] h-auto object-contain"
        />
      </div>

      {/* Heading */}
      <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
        <h1 className="text-2xl font-bold tracking-tight text-foreground">
          {t("auth.login.title")}
        </h1>
        <p className="mt-1.5 text-sm text-muted-foreground">
          {t("auth.login.subtitle")}
        </p>
      </div>
    </div>
  )
}
